import { COLOR } from 'src/constants/colors'
import { ColorHandler } from 'src/utils/style.utils'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { useTranslation } from 'react-i18next'
import { HomeDataPropsType } from 'src/views/Service/Home'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import Span from 'src/components/atomic/atom/Span'
import Button from 'src/components/atomic/atom/Button'
import TextArea from 'src/components/atomic/atom/TextArea'
import Div from 'src/components/atomic/atom/Div'
import Spinner from 'src/components/atomic/atom/Spinner'
import Svg from 'src/components/atomic/atom/Svg'
import React, { forwardRef } from 'react'
import styled from 'styled-components'

const HomeLockScreenMsg = forwardRef(
  (props: { data: HomeDataPropsType }, msgInputRef?: React.Ref<HTMLTextAreaElement>) => {
    const {
      MsgTextAreaBlur,
      onLockMsgSubmit,
      onMsgTextAreaContentsDelete,
      onLockMsgTextAreaChange,
      onMsgTextAreaFocus,
    } = props.data
    const { setMediaStyle } = useMediaQueryHook()
    const { t } = useTranslation()
    const { TempValue } = useAppSelector((state: RootState) => state.HomePage)
    const { Connection } = useAppSelector((state: RootState) => state.connection)

    return (
      <>
        <Span option="title" $margin={setMediaStyle('0 0 4.5px 0', '0 0 7.5px 0', '0 0 7.5px 0')}>
          {t('HOME.MESSAGE_TITLE', { defaultValue: 'Lock screen message' })}
        </Span>
        <Span option="tiny" $text_align={'left'} color={COLOR.black70} $margin={'0 0 12px 0'}>
          {t('HOME.MESSAGE_DESC', {
            defaultValue: 'Message appears on the Lock Screen of your lost device.',
          })}
        </Span>
        <Div width={'100%'} style={{ position: 'relative' }}>
          <>
            {TempValue.LockMsg === null ? (
              <Spinner $top={'50%'} $height={'100px'} />
            ) : (
              <>
                <button
                  tabIndex={0}
                  id={'screen_msg'}
                  className={'screen_msg'}
                  style={{
                    position: 'absolute',
                    top: '18px',
                    right: '16px',
                    border: 'none',
                    background: 'transparent',
                  }}
                  onClick={onMsgTextAreaContentsDelete}
                >
                  <Svg
                    name={'xIcon'}
                    width={'18px'}
                    height={'18px'}
                    className={'screen_msg'}
                    style={{
                      pointerEvents: 'none',
                      cursor: Connection ? 'pointer' : 'default',
                    }}
                  />
                </button>
                <LockMsgTextArea
                  ref={msgInputRef}
                  fontSize={'16px'}
                  $padding={'14px 50px 14px 16px'}
                  value={TempValue.LockMsg as string}
                  placeholder={`${t('HOME.LOCKMSG_DEFAULT_MSG')}`}
                  onBlur={MsgTextAreaBlur}
                  onFocus={onMsgTextAreaFocus}
                  onChange={onLockMsgTextAreaChange}
                  maxLength={200}
                  disabled={!Connection}
                  $min_height={'54px'}
                />
                <Button
                  $tabIndex={0}
                  id={'screen_msg'}
                  className={'screen_msg'}
                  option={'bigDefault'}
                  disabled={!Connection}
                  $margin={setMediaStyle('0 0 32px 0', '0 0 32px 0', '0 0 45px 0')}
                  $bgColor={ColorHandler(Connection, 'brand_black10')}
                  onClick={onLockMsgSubmit}
                >
                  <Span option={'medium_bold'} color={ColorHandler(Connection, 'white_black30')} className={'screen_msg'}>
                    {t('BUTTON.SAVE', { defaultValue: 'Save' })}
                  </Span>
                </Button>
              </>
            )}
          </>
        </Div>
      </>
    )
  },
)
export default HomeLockScreenMsg

const LockMsgTextArea = styled(TextArea)`
  line-height: 1.6;
  padding: 14px 50px 14px 16px;
  min-height: 54px;

  &::placeholder {
    line-height: 1.6;  
  }
`